import { graphql } from "react-relay";

export const QUERY_FRAGMENT = graphql`
	fragment licensesTable_LicensesFragment on Query
	@refetchable(queryName: "licensesTable_Refetch")
	@argumentDefinitions(
		first: { type: "Int" }
		after: { type: "String" }
		nameOpt: { type: "String" }
	) {
		Admin {
			Auth {
				SelectAccounts(first: $first, after: $after, nameOpt: $nameOpt, ids: [])
					@connection(key: "licensesTable_SelectAccounts") {
					pageInfo {
						startCursor
						endCursor
						hasNextPage
						hasPreviousPage
					}
					edges {
						node {
							...licensesTable_AccountFragment
								@arguments(first: $first, after: $after)
						}
					}
				}
			}
		}
	}
`;
export const ACCOUNT_FRAGMENT = graphql`
	fragment licensesTable_AccountFragment on Account
	@inline
	@argumentDefinitions(first: { type: "Int" }, after: { type: "String" }) {
		id
		name
		extension(accountExtensionKind: Tka) {
			... on TkaAccountExtension {
				licenses(first: $first, after: $after) @connection(key: "licensesTable_licenses") {
					__id
					edges {
						node {
							...licensesTable_LicenseFragment
						}
					}
				}
			}
		}
	}
`;

export const LICENSE_FRAGMENT = graphql`
	fragment licensesTable_LicenseFragment on License @inline {
		id
		creationInfo {
			kind
			createdAt
			licenseDefinition {
				data {
					name
				}
			}
			... on LicenseCreatedByOrder {
				orderId
			}
			... on LicenseCreatedByAdmin {
				creatorId
			}
			... on LicenseCreatedByRegistration {
				userId
			}
		}
		usage {
			kind

			... on LicenseUsageUsedForTree {
				at
				forUser {
					email
				}
			}
		}
		certificationData {
			__typename
			kind
		}
		timeBasedInfo {
			startDateTime
			endDateTime
		}
	}
`;
